import axios from "axios";

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const API =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  (isLocalhost ? "http://localhost:5003" : window.location.origin);

export const api = axios.create({
  baseURL: `${API}/api`,
  timeout: 60000,
});

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("softvolute_token");

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export const errorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

export const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatMoney = (value) =>
  `₹ ${Number(value || 0).toLocaleString("en-IN")}`;

export function DetailRow({ label, value }) {
  return (
    <div className="as-detail-row">
      <span>{label}</span>
      <strong>{value || "-"}</strong>
    </div>
  );
}